import React from "react";
import PropTypes from "prop-types";
import { StyledList } from "./styled";
import Divider from "../Divider";

const List = ({ children, noDivider, customStyle }) => {
    return (
        <StyledList
            customStyle={customStyle}
        >
            {React.Children.map(children, (child, index) => (
                <React.Fragment key={index}>
                    {child}
                    {!noDivider && index < children.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </StyledList>
    );
};

List.propTypes = {
    children: PropTypes.node,
    noDivider: PropTypes.bool,
    customStyle: PropTypes.array
};

List.defaultProps = {
    noDivider: false
};

export default React.memo(List);
